import Chart from 'chart.js'

/**
 * @module
 * @name chartBar
 */
export default {
  name: 'chartBar',
  props: {
    chartType: {
      type: String
    },
    barThicknessChart: {
      type: Number
    },
    barLenghtChart: {
      type: Number
    },
    stepSizeBarX: {
      type: String
    },
    stepSizeBarY: {
      type: String
    },
    dataBarChart: {
      type: Array
    },
    isAxeHidden: {
      type: Boolean
    },
    titleBarChart: {
      type: String
    },
    isTitledisplayed: {
      type: Boolean
    },
    areGridsHidden: {
      type: Boolean
    }
  },
  data () {
    return {
      barChart: null
    }
  },
  watch: {
    dataBarChart (dataChart) {
      this.barChart.data.labels = this.handleGetDataChart(dataChart, 'label')
      this.barChart.data.datasets.forEach((dataset) => {
        dataset.data = this.handleGetDataChart(dataChart, 'amount')
      })
      this.barChart.update()
    }
  },
  methods: {
    handleGetDataChart (arrData, elem) {
      let arrDataItems = arrData.map(item => {
        return item[elem]
      })
      return arrDataItems
    },
    abbreviateNumber (value) {
      var newValue = value
      if (value >= 1000) {
        var suffixes = ['', 'k', 'm', 'b', 't']
        var suffixNum = Math.floor(('' + value).length / 3)
        var shortValue = ''
        for (var precision = 2; precision >= 1; precision--) {
          shortValue = parseFloat((suffixNum !== 0 ? (value / Math.pow(1000, suffixNum)) : value).toPrecision(precision))
          var dotLessShortValue = (shortValue + '').replace(/[^a-zA-Z 0-9]+/g, '')
          if (dotLessShortValue.length <= 2) { break }
        }
        if (shortValue % 1 !== 0) shortValue = shortValue.toFixed(1)
        newValue = shortValue + suffixes[suffixNum]
      }
      return newValue
    },
    getStepSize (arr) {
      const amounts = arr.map(elem => elem.amount)
      const greatestAmount = Math.trunc(Math.max(...amounts))
      if (greatestAmount <= 100) {
        return 10
      } else if (greatestAmount <= 1000) {
        return 100
      } else if (greatestAmount <= 10000) {
        return 1000
      } else if (greatestAmount <= 100000) {
        return 10000
      } else if (greatestAmount <= 1000000) {
        return 100000
      }
    },
    getTotalIncreaseAmount (arr) {
      const amounts = arr.map(elem => elem.amount)
      const greatestAmount = Math.trunc(Math.max(...amounts))
      const totalIncreaseAmount = greatestAmount + ((greatestAmount * 20) / 100)
      return totalIncreaseAmount
    },
    handleCreateBarChart (dataChart) {
      this.barChart = new Chart(this.$el, {
        type: this.chartType,
        data: {
          labels: this.handleGetDataChart(dataChart, 'label'),
          datasets: [{
            label: 'bar',
            backgroundColor: '#007DE3',
            borderColor: '#007DE3',
            data: this.handleGetDataChart(dataChart, 'amount'),
            barThickness: this.barThicknessChart,
            minBarLength: this.barLenghtChart
          }]
        },
        options: {
          title: {
            display: !!this.isTitledisplayed,
            text: this.titleBarChart
          },
          maintainAspectRatio: false,
          responsive: true,
          legend: {
            display: false
          },
          scales: {
            xAxes: [{
              gridLines: {
                display: !this.areGridsHidden
              },
              ticks: {
                display: !this.isAxeHidden,
                autoSkip: false,
                maxRotation: 0,
                suggestedMax: this.getTotalIncreaseAmount(dataChart),
                stepSize: this.getStepSize(dataChart),
                callback: function (value) {
                  const isValueNumber = typeof (value) === 'number'
                  const isValueThisAmount = value >= 1000 || value === 0
                  const valueIncludes0 = value.toString().includes('0')
                  if (value === 0) {
                    return value + 'k'
                  } else if (isValueNumber && isValueThisAmount && valueIncludes0) {
                    return value.toString().slice(0, -3) + 'k'
                  }
                  return value
                }
              }
            }],
            yAxes: [{
              ticks: {
                fontSize: 12,
                beginAtZero: true,
                stepSize: this.stepSizeBarY,
                callback: function (value) {
                  const isValueNumber = typeof (value) === 'number'
                  const isValueThisAmount = value >= 1000 || value === 0
                  const valueIncludes0 = value.toString().includes('0')
                  if (value === 0) {
                    return value + 'k'
                  } else if (isValueNumber && isValueThisAmount && valueIncludes0 && value > 0) {
                    return value.toString().slice(0, -3) + 'k'
                  }
                  return value
                }

              }

            }]
          }
        }
      })
    }
  },
  mounted () {
    this.handleCreateBarChart(this.dataBarChart)
  }
}
